module.exports = __webpack_public_path__ + "static/media/plus_normal.607dd3b9.svg";